import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Scale365Section from '../components/scale365/Scale365Section';
import WhatsNewSection from '../components/whatsnew/WhatsNewSection';
import VmwareMigrationSection from '../components/whatsnew/VmwareMigrationSection';
import CompanyDescription from '../components/company/CompanyDescription';
import SolutionsSection from '../components/products/SolutionsSection';
import ServiceSection from '../components/services/ServiceSection';
import ExpertiseSection from '../components/expertise/ExpertiseSection';
import InfrastructureSection from '../components/infrastructure/InfrastructureSection';
import MailGatewaySection from '../components/mailgateway/MailGatewaySection';
import MigrationSection from '../components/migration/MigrationSection';
import WorkflowSection from '../components/workflow/WorkflowSection';
import ADSyncSection from '../components/adsync/ADSyncSection';
import SaaSSection from '../components/saas/SaaSSection';
import LemonLDAPSection from '../components/lemonldap/LemonLDAPSection';
import NextcloudSection from '../components/nextcloud/NextcloudSection';
import OpenLDAPSection from '../components/openldap/OpenLDAPSection';
import ERPSection from '../components/erp/ERPSection';
import SupportSection from '../components/support/SupportSection';
import TrainingSection from '../components/sections/TrainingSection';
import PartnershipsSection from '../components/partnerships/PartnershipsSection';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <div id="home">
        <Hero />
      </div>
      <div id="scale365">
        <Scale365Section />
      </div>
      <div id="whatsnew">
        <WhatsNewSection />
      </div>
      <div id="vmware-migration">
        <VmwareMigrationSection />
      </div>
      <div id="company">
        <CompanyDescription />
      </div>
      <div id="solutions">
        <SolutionsSection />
      </div>
      <div id="services">
        <ServiceSection />
      </div>
      <div id="expertise">
        <ExpertiseSection />
      </div>
      <div id="infrastructure">
        <InfrastructureSection />
      </div>
      <div id="mailgateway">
        <MailGatewaySection />
      </div>
      <div id="migration">
        <MigrationSection />
      </div>
      <div id="workflow">
        <WorkflowSection />
      </div>
      <div id="adsync">
        <ADSyncSection />
      </div>
      <div id="saas">
        <SaaSSection />
      </div>
      <div id="lemonldap">
        <LemonLDAPSection />
      </div>
      <div id="nextcloud">
        <NextcloudSection />
      </div>
      <div id="openldap">
        <OpenLDAPSection />
      </div>
      <div id="erp">
        <ERPSection />
      </div>
      <div id="support">
        <SupportSection />
      </div>
      <div id="training">
        <TrainingSection />
      </div>
      <div id="partnerships">
        <PartnershipsSection />
      </div>
      <div id="contact">
        <Contact />
      </div>
      <Footer />
    </div>
  );
};

export default HomePage;